import { BasepageDirective } from "./basepage.directive";
import { ClickOutsideDirective } from "./clickoutside.directive";
import { InViewDirective } from "./in-view.directive";
import { RegisterButtonDirective } from "./register-button.directive";
import { TrapFocusDirective } from "./trap-focus.directive";

export const UI_DIRECTIVES = [BasepageDirective, ClickOutsideDirective, InViewDirective, RegisterButtonDirective, TrapFocusDirective];
